import { gql, useQuery } from "@apollo/client";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import { useState } from "react";
import { BsArrowDownCircleFill, BsZoomIn, BsZoomOut } from "react-icons/bs";
import { useDebounce } from "use-debounce";

const FETCH_SHIPPING_MARK_PREVIEW = gql`
  query FETCH_SHIPPING_MARK_PREVIEW(
    $item: String!
    $x: Float!
    $y: Float!
    $z: Float!
    $barcode: String!
    $barcodeType: String!
    $newLogo: Boolean!
    $itemNumber: String
    $values: ShippingMarkValuesInputType!
    $notes: String
    $mainFontScale: Float
    $sideFontScale: Float
    $rotate: Boolean
    $template: String
    $moveUp: Boolean
    $innerCartonPcs: Int
  ) {
    previewShippingMark(
      item: $item
      x: $x
      y: $y
      z: $z
      barcode: $barcode
      barcodeType: $barcodeType
      newLogo: $newLogo
      itemNumber: $itemNumber
      values: $values
      notes: $notes
      mainFontScale: $mainFontScale
      sideFontScale: $sideFontScale
      rotate: $rotate
      template: $template
      moveUp: $moveUp
      innerCartonPcs: $innerCartonPcs
    )
  }
`;

const ShippingMarkPreview = ({ variables }) => {
  const [debouncedValues] = useDebounce(variables, 500);

  const modifiedVariables = { ...debouncedValues };
  if (modifiedVariables.template === "US") {
    modifiedVariables.itemNumber = "";
  }

  const { data, error, loading } = useQuery(FETCH_SHIPPING_MARK_PREVIEW, {
    variables: modifiedVariables,
    fetchPolicy: "network-only",
  });
  const [zoom, setZoom] = useState(20);
  function zoomIn() {
    setZoom(zoom + 10);
  }

  function zoomOut() {
    if (zoom > 10) {
      setZoom(zoom - 10);
    }
  }

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  function download() {
    const url = `data:application/pdf;base64,${data.previewShippingMark}`;
    const link = document.createElement("a");
    link.href = url;
    const fileNamePrefix = variables.innerCartonPcs
      ? `Shipping mark - inner carton - ${variables.item}`
      : `Shipping mark - ${variables.item}`;

    const fileName = variables.itemNumber
      ? `${fileNamePrefix} - ${variables.itemNumber}.pdf`
      : `${fileNamePrefix}.pdf`;

    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
  }

  if (!data) return null;

  return (
    <div className="flex-1 flex flex-col relative">
      <iframe
        key={zoom}
        className="w-full h-full flex-1 border-0"
        src={`data:application/pdf;base64,${data.previewShippingMark}#toolbar=0&zoom=${zoom}`}
      />
      <div className="flex space-x-6 absolute top-4 left-4 ">
        <Button
          className="rounded-md px-3 py-2 transition-colors hover:bg-sky-100 active:bg-sky-200 dark:hover:bg-sky-900/60 dark:active:bg-sky-800/70"
          onClick={zoomIn}
          icon={<BsZoomIn className="mr-2" />}
        >
          Zoom In
        </Button>
        <Button
          className="rounded-md px-3 py-2 transition-colors hover:bg-sky-100 active:bg-sky-200 dark:hover:bg-sky-900/60 dark:active:bg-sky-800/70"
          onClick={zoomOut}
          icon={<BsZoomOut className="mr-2" />}
        >
          Zoom Out
        </Button>
        <Button
          className="rounded-md px-3 py-2 transition-colors hover:bg-sky-100 active:bg-sky-200 dark:hover:bg-sky-900/60 dark:active:bg-sky-800/70"
          onClick={download}
          icon={<BsArrowDownCircleFill className="mr-2" />}
        >
          Download
        </Button>
      </div>
    </div>
  );
};

export default ShippingMarkPreview;
